<div
  class="timesheet__item timesheet__status timesheet-column--status"
  [ngClass]="{
    'timesheet__status--approved': timesheet.status === 'Approved',
    'timesheet__status--declined': timesheet.status === 'Declined',
    'timesheet__status--pending': timesheet.status === 'Pending',
  }"
></div>

<div
  class="timesheet__item timesheet-warning-container timesheet-column--start"
  [ngClass]="{
    warning:
      form.controls['starttime'].invalid && form.controls['starttime'].touched && form.controls['starttime'].dirty,
  }"
>
  <time-input [hideInputAddon]="true" name="starttime" [formControl]="form.get('starttime')"></time-input>

  <shift-warning
    class="timesheet-warning_icon"
    [deviatesFromSchedule]="deviationsFromSchedule.starttime"
  ></shift-warning>
</div>

<div class="timesheet__item timesheet-column--end">--:--</div>

@if (cols.break) {
  <div class="timesheet__item timesheet-warning-container timesheet-column--break">
    {{ timesheet.break }}
    <shift-warning class="timesheet-warning_icon" [deviatesFromSchedule]="deviationsFromSchedule.break"></shift-warning>
  </div>
}

@if (cols.paidBreak) {
  <div class="timesheet__item timesheet-warning-container timesheet-column--paid-break">
    {{ timesheet.paid_break }}
    <shift-warning
      class="timesheet-warning_icon"
      [deviatesFromSchedule]="deviationsFromSchedule.paid_break"
    ></shift-warning>
  </div>
}

@if (cols.location) {
  <div class="timesheet__item timesheet-column--location">
    <timesheet-info
      [text]="selectedLocation.name"
      [deviatesFromSchedule]="deviationsFromSchedule.location"
    ></timesheet-info>
  </div>
}

@if (cols.department) {
  <div
    class="timesheet__item timesheet-warning-container timesheet-column--department"
    [ngClass]="{
      warning:
        form.controls['department_id'].invalid &&
        form.controls['department_id'].touched &&
        form.controls['department_id'].dirty,
    }"
  >
    <select name="departmentId" sbInput [formControl]="form.get('department_id')">
      <option value="" disabled [hidden]="form.controls['department_id'].value !== ''"></option>
      @for (optGroup of departmentOptions; track optGroup) {
        <optgroup [attr.label]="optGroup.location.name">
          @for (department of optGroup.departments; track department) {
            <option [value]="department.id" [disabled]="department.isClosed">
              {{ department.name }}
            </option>
          }
        </optgroup>
      }
    </select>
    <shift-warning
      class="timesheet-warning_icon"
      [deviatesFromSchedule]="deviationsFromSchedule.department"
    ></shift-warning>
  </div>
}

@if (cols.team) {
  <div
    class="timesheet__item timesheet-warning-container timesheet-column--team"
    [ngClass]="{ warning: form.controls['team_id'].invalid }"
  >
    <select sbInput [formControl]="form.get('team_id')">
      <option value="" disabled [hidden]="form.controls['team_id'].value !== ''"></option>
      @for (teamOption of teamOptions; track teamOption) {
        <option [value]="teamOption.value">{{ teamOption.label }}</option>
      }
    </select>
    <shift-warning class="timesheet-warning_icon" [deviatesFromSchedule]="deviationsFromSchedule.team"></shift-warning>
  </div>
}

@if (cols.shift) {
  <div
    class="timesheet__item timesheet-warning-container timesheet-column--shift"
    [ngClass]="{ warning: form.controls['shift_id'].invalid }"
  >
    <select sbInput [formControl]="form.get('shift_id')">
      <option value="" disabled [hidden]="form.controls['shift_id'].value !== ''"></option>
      @for (shiftOption of shiftOptions; track shiftOption) {
        <option [value]="shiftOption.value">{{ shiftOption.label }}</option>
      }
    </select>
    <shift-warning class="timesheet-warning_icon" [deviatesFromSchedule]="deviationsFromSchedule.shift"></shift-warning>
  </div>
}

@if (cols.surcharge) {
  <div
    class="timesheet__item timesheet-column--surcharge"
    [ngClass]="{
      warning:
        form.controls['rate_card_id'].invalid &&
        form.controls['rate_card_id'].touched &&
        form.controls['rate_card_id'].dirty,
    }"
  >
    @if (rateCardOptions && selectedDepartment?.timesheet_surcharges) {
      <select sbInput [formControl]="form.get('rate_card_id')">
        <option value="" disabled [hidden]="form.controls['rate_card_id'].value !== ''"></option>
        @for (rateCard of rateCardOptions; track rateCard) {
          <option [ngValue]="rateCard.value">{{ rateCard.label }}</option>
        }
      </select>
    }
    @if (!selectedDepartment?.timesheet_surcharges && selectedRateCard) {
      {{ selectedRateCard.name }}
      @if (selectedRateCard.deleted) {
        <span>- {{ selectedRateCard.deleted_date | localeDate }}</span>
      }
    }
  </div>
}
@if (cols.km) {
  <div
    class="timesheet__item timesheet-column--km"
    [ngClass]="{
      warning:
        form.controls['kilometers'].invalid && form.controls['kilometers'].touched && form.controls['kilometers'].dirty,
    }"
  >
    @if (selectedDepartment?.km_registration) {
      <decimal-input name="kilometers" [formControl]="form.get('kilometers')"></decimal-input>
    }
    @if (!selectedDepartment?.km_registration) {
      {{ form.controls['kilometers'].value | decimal }}
    }
  </div>
}

@if (cols.meals) {
  <div
    class="timesheet__item timesheet-column--meals"
    [ngClass]="{
      warning: form.controls['meals'].invalid && form.controls['meals'].touched && form.controls['meals'].dirty,
    }"
  >
    @if (selectedDepartment?.meal_registration) {
      <input name="meals" [formControl]="form.get('meals')" class="input-small" type="number" min="0" />
    }
    @if (!selectedDepartment?.meal_registration) {
      {{ form.controls['meals'].value | decimal }}
    }
  </div>
}

@if (cols.note) {
  <app-timesheet-row-edit-textarea
    class="timesheet__item timesheet-column--note"
    [value]="timesheet?.note"
    [isSaving]="timesheet?.saving"
    (saved)="onNoteChange($event)"
  ></app-timesheet-row-edit-textarea>
}

<timesheet-row-custom-fields
  [timesheet]="timesheet"
  [canEdit]="true"
  [columns]="customFieldCols"
  [customFields]="customFields"
></timesheet-row-custom-fields>

<div class="timesheet__item timesheet-column--details">
  <timesheet-details
    [timesheet]="timesheet"
    [absenceWarning]="absenceWarning"
    [doubleRegistration]="doubleRegistration"
    [cols]="cols"
  ></timesheet-details>
</div>
